import { handleAuthorization, handleOkResponseJson, handleBadRequest400 } from "./handlers"
import { obterToken } from "./loginService"
import { abrirBlobPdf, fecharJanelaPdf } from "./pdfHelper"
import * as axios from 'axios';

export default {
    obterPedidosAsync,
    editarPedidoAsync
}

export const obterPedidosAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Pedido/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const obterPedidosEntradaAsync = async (idEntradaAtual = null) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    const query = idEntradaAtual ? `?idEntradaAtual=${encodeURIComponent(idEntradaAtual)}` : "";
    return fetch(`${process.env.VUE_APP_API_URL}/Pedido/obterListaEntrada${query}`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}


export const editarPedidoAsync = async (id, items) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, items })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Pedido/atualizar`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}

export const aprovarPedidoAsync = async (id) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Pedido/aprovar`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const inativarPedidoAsync = async (id, justificativa, formData = null) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Authorization': 'bearer ' + obterToken() },
        body: formData
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Pedido/inativar/` + id + `/` + encodeURIComponent((justificativa || "").trim()), requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson);
}

export const enviarPedidoAsync = async (formData, id) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Authorization': 'bearer ' + obterToken() }, // sem 'Content-Type' — o browser define!
		body: formData
	};

	return fetch(`${process.env.VUE_APP_API_URL}/Pedido/enviarPdf/` + id, requestOptions)
		.then(handleAuthorization)
		.then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
};
export const alterarStatusEnviado = async (id) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Authorization': 'bearer ' + obterToken() }, // sem 'Content-Type' — o browser define!
	};

	return fetch(`${process.env.VUE_APP_API_URL}/Pedido/statusEnviado/` + id, requestOptions)
		.then(handleAuthorization)
		.then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
};
export function getPdf(id, janelaPdf = null) {
    try {
        return axios({
            url: `${process.env.VUE_APP_ROOT_API}/Pedido/downloadPdf/` + id,
            method: 'GET',
            responseType: 'blob',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        }).catch(() => {
            fecharJanelaPdf(janelaPdf);
            return { status: false };
        })
            .then((response) => {
                if (response.status === false) {
                    fecharJanelaPdf(janelaPdf);
                    return response;
                }
                abrirBlobPdf(response.data, janelaPdf);
            });
    } catch (e) {
        fecharJanelaPdf(janelaPdf);
        throw e;
    }
}
